import { render } from "./main-template.vue?vue&type=template&id=271a8612&scoped=true&ts=true"
import script from "./main-template.vue?vue&type=script&lang=ts"
export * from "./main-template.vue?vue&type=script&lang=ts"

import "./main-template.vue?vue&type=style&index=0&id=271a8612&scoped=true&lang=css"

import exportComponent from "C:\\Paii\\Projects\\TT Exclusive\\ttex_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271a8612"]])

export default __exports__